// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"648":"43975524","703":"ed3634a1"}[chunkId] + ".chunk.js";
};